export const PRODUCT_CONDITIONS = [
  { value: "NEW", label: "New" },
  { value: "USED_LIKE_NEW", label: "Used - Like New" },
  { value: "USED_GOOD", label: "Used - Good" },
  { value: "USED_FAIR", label: "Used - Fair" },
  { value: "REFURBISHED", label: "Refurbished" },
];

export const ALLOWED_CURRENCIES = [
  { value: "ETB", label: "ETB" },
  { value: "USD", label: "USD" },
];
export const WEIGHT_UNIT = [
  { value: "kg", label: "Kg" },
  { value: "g", label: "g" },
];
export const DIMENSION_UNIT = [
  { value: "cm", label: "cm" },
  { value: "inch", label: "inch" },
];
